import React from "react";
import { statusMeta, duracionLabel } from "../turnos/agenda/agendaLayout";
import { useClientesApi } from "./clientesApi";
import { fechaAR } from "./clientesUtils";
import useCarga from "./useCarga";
import "./clientes.css";

/* Historial de la ficha (hasta 100 filas, de todos los locales y rubros del negocio): turnos de Beauty, reservas de
   cancha y de mesa. Un profesional de Beauty ve solo los suyos. Cada fila lleva el local y una insignia del rubro. */

export const KIND_BADGE = { beauty: "Turno", court: "Cancha", table: "Mesa" };

const personasLabel = (n) => (Number(n) === 1 ? "1 persona" : `${Number(n) || 0} personas`);

// Detalle propio de cada rubro; lo común (fecha, estado, local) lo pone `FilaHistorial`.
const detalleDe = (fila) => {
  if (fila.kind === "court") {
    return [fila.courtName || "Cancha", fila.sport, fila.durationMinutes ? duracionLabel(fila.durationMinutes) : ""].filter(Boolean);
  }
  if (fila.kind === "table") {
    return [[fila.tableLabel || "Mesa", fila.zone].filter(Boolean).join(" · "), fila.partySize ? personasLabel(fila.partySize) : ""].filter(Boolean);
  }
  return [fila.professionalName || "Sin profesional", (fila.services || []).map((s) => s.name).join(", ") || "Sin servicios"];
};

export const FilaHistorial = ({ fila }) => (
  <li>
    <strong>{fechaAR(fila.date)} · {fila.slotStart}–{fila.slotEnd}</strong>
    <span className={`fc-kind fc-kind--${fila.kind || "beauty"}`}>{KIND_BADGE[fila.kind] || KIND_BADGE.beauty}</span>
    <span>{statusMeta(fila.status).label || fila.status}</span>
    {fila.venueName && <span>{fila.venueName}</span>}
    {detalleDe(fila).map((texto, i) => <span key={i}>{texto}</span>)}
  </li>
);

const ClienteHistorial = ({ clientId }) => {
  const api = useClientesApi();
  const historial = useCarga(() => api.history(clientId), clientId, {
    valida: (info) => Array.isArray(info.items),
    mensaje: "No pudimos cargar el historial. Probá de nuevo.",
  });
  const data = historial.data;

  return (
    <section className="fc-card" aria-labelledby="fc-historial-title">
      <h3 id="fc-historial-title">Historial de reservas</h3>
      {historial.loading && !data && <p role="status">Cargando historial…</p>}
      {historial.error && (
        <div className="fc-error" role="alert">
          {historial.error.message}
          <button type="button" className="zr-btn zr-btn--soft" onClick={historial.reload}>Reintentar</button>
        </div>
      )}
      {data?.scope === "own" && <p className="fc-hint">Solo se muestran los turnos de tu agenda.</p>}
      {data?.truncated && <p className="fc-hint">Mostramos las 100 reservas más recientes.</p>}
      {data && data.items.length === 0 && (
        <div className="fc-empty">
          <p>Este cliente todavía no tiene reservas.</p>
          <p>Cuando reserve o cargues una reserva vinculada a esta ficha, aparece acá.</p>
        </div>
      )}
      {data && data.items.length > 0 && (
        <ul className="fc-history" aria-label="Reservas del cliente">
          {data.items.map((fila) => <FilaHistorial key={fila._id} fila={fila} />)}
        </ul>
      )}
    </section>
  );
};

export default ClienteHistorial;
